document.addEventListener('DOMContentLoaded', () => {
  // ① Ensure one counter container
  let counter = document.getElementById('search-scroll-counter');
  if (!counter) {
    counter = document.createElement('div');
    counter.id = 'search-scroll-counter';
    counter.style.display = 'none';
    document.body.appendChild(counter);
  }

  // ② Utility to grab only real, visible search results (no banners)
  const getItems = () => {
    return Array.from(
      document.querySelectorAll('.grid__item:not(.grid__banner-item)')
    ).filter(item => {
      // must be in the layout and not display:none
      if (!item.offsetParent) return false;
      // must contain a product link
      return !!item.querySelector('a[href*="/products/"]');
    });
  };

  // ③ Fetch & inline your stroke-based SVG arrow
  fetch(window.scrollArrowIcon)
    .then(r => r.text())
    .then(svgText => {
      const inlineSvg = svgText
        .replace(/(?:width|height)="[^"]*"/g, '')
        .replace(/stroke="[^"]*"/g, 'stroke="none"')
        .replace(/fill="[^"]*"/g, 'fill="currentColor"');

      // ④ Build the pill markup
      counter.innerHTML = `
        ${inlineSvg}
        <span id="search-term" style="margin:0 0.5rem; white-space:nowrap;">
          ${window.searchQuery || ''}
        </span>
        <span id="scroll-count">0/0</span>
      `;
      const countText = document.getElementById('scroll-count');

      // ⑤ Make the whole pill clickable → scroll to top + hide
      counter.style.cursor = 'pointer';
      counter.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        counter.style.display = 'none';
      });

      // ⑥ Update & show/hide on scroll
      const updateCounter = () => {
        const items = getItems();
        const total = items.length;
        const scrolled = items.filter(
          p => p.getBoundingClientRect().top < 0
        ).length;
        countText.textContent = `${scrolled}/${total}`;
      };

      window.addEventListener('scroll', () => {
        const pct = window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight);
        if (pct >= 0.05) {
          updateCounter();
          counter.style.display = 'flex';
        } else {
          counter.style.display = 'none';
        }
      });

      // ⑦ Watch for filter/sort DOM changes and refresh counts if visible
      const grid = document.querySelector('#product-grid ul.grid');
      if (grid) {
        new MutationObserver(() => {
          if (counter.style.display === 'flex') updateCounter();
        }).observe(grid, { childList: true, subtree: true });
      }

      // ⑧ Initial count in case we start mid-scroll
      updateCounter();
    })
    .catch(err => console.error('Search Scroll Counter failed to load SVG:', err));
});
